export function formatRelativeTime(dateStr: string): string {
  const now = Date.now();
  const date = new Date(dateStr).getTime();
  const diffMs = now - date;
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffSec < 60) return "agora";
  if (diffMin < 60) return `${diffMin}min atras`;
  if (diffHour < 24) return `${diffHour}h atras`;
  if (diffDay === 1) return "ontem";
  if (diffDay < 7) return `${diffDay}d atras`;
  if (diffDay < 30) return `${Math.floor(diffDay / 7)}sem atras`;

  return new Date(dateStr).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}
